import type { FlexProps } from 'antd';
import { useResolveSpacingValue } from '../../hooks';

type GapValue = FlexProps['gap'];

export const useGetGap = ({ gap }: { gap?: GapValue }): GapValue => {
  const resolveSpacingValue = useResolveSpacingValue();

  if (!gap) {
    return undefined;
  }

  return resolveSpacingValue({ value: gap });
};
